"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightTheme = void 0;
var lightTheme_1 = require("./lightTheme");
Object.defineProperty(exports, "lightTheme", { enumerable: true, get: function () { return lightTheme_1.lightTheme; } });
//# sourceMappingURL=index.js.map